import { createCtx } from "../hooks/createCtx";
type ModifyContext = {
  handleModeSwitch: () => void;
  handleDelete?: () => void;
};

export const [useModifyContext, ModifyContextProvider] =
  createCtx<ModifyContext>();
